"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FunnelFormComponent = void 0;
const React = __importStar(require("react"));
const PageContent_1 = __importDefault(require("src/hello_assets/src/components/ui/common/content/PageContent"));
const antd_1 = require("antd");
const PeriodDaysComponent_1 = require("src/hello_assets/src/components/ui/loggedin/content/project/withData/features/common/PeriodDaysComponent");
const ChartShowButtonComponent_1 = require("src/hello_assets/src/components/ui/loggedin/content/project/withData/common/ChartShowButtonComponent");
const FunnelPageDataProvider_1 = require("src/hello_assets/src/components/ui/loggedin/content/project/withData/features/funnel/FunnelPageDataProvider");
const FunnelPageModelProvider_1 = require("src/hello_assets/src/components/ui/loggedin/content/project/withData/features/funnel/FunnelPageModelProvider");
const lodash_1 = __importDefault(require("lodash"));
const FunnelJSONModel_1 = require("src/hello_assets/src/components/ui/loggedin/content/project/withData/features/funnel/model/FunnelJSONModel");
const QueryEventVariantsComponent_1 = require("src/hello_assets/src/components/ui/loggedin/content/project/withData/common/event/queryEventVariant/QueryEventVariantsComponent");
const QueryEventVariantNameComponent_1 = require("src/hello_assets/src/components/ui/loggedin/content/project/withData/common/event/queryEventVariant/QueryEventVariantNameComponent");
const use_custom_compare_1 = require("use-custom-compare");
const FunnelConversionWindow_1 = require("src/hello_assets/src/components/ui/loggedin/content/project/withData/features/funnel/state/data/form/FunnelConversionWindow");
const FunnelFormComponent = () => {
    const pageDataContext = (0, FunnelPageDataProvider_1.useFunnelPageDataContext)();
    const pageModelContext = (0, FunnelPageModelProvider_1.useFunnelPageModelContext)();
    const jsonModel = pageModelContext.pageModelStateFns.getFormJSONModel();
    const last = jsonModel.getPeriodDaysJSONModel().getLast();
    const funnelQueryJSONModel = jsonModel.getFunnelQueryJSONModel();
    const filledEventNames = funnelQueryJSONModel.getFilledEventNamesSet();
    const funnelQueryJSONModelSerializedState = funnelQueryJSONModel.serialize();
    const showButtonDisabled = FunnelJSONModel_1.FunnelJSONModel.isModelEmpty(jsonModel.serialize());
    const transformOptionsFn = (0, use_custom_compare_1.useCustomCompareMemo)(() => {
        return (0, QueryEventVariantNameComponent_1.createTransformOptions)({
            filledEventNames: filledEventNames,
            filterOutEventsForUniqueness: true,
            specialEvents: ["newUser", "session", "anyEvent"]
        });
    }, [filledEventNames], lodash_1.default.isEqual);
    return React.createElement(React.Fragment, null,
        React.createElement(antd_1.Form, null,
            React.createElement(PageContent_1.default.CardSection, null),
            React.createElement(antd_1.Row, { gutter: 12 },
                React.createElement(antd_1.Col, null,
                    React.createElement(PeriodDaysComponent_1.PeriodDaysComponent, { value: last, onChange: pageModelContext.pageModelStateFns.onPeriodChanged })),
                React.createElement(antd_1.Col, null,
                    React.createElement(FunnelConversionWindow_1.FunnelConversionWindow, null))),
            React.createElement(PageContent_1.default.CardSection, null, "Funnel Events"),
            React.createElement(antd_1.Row, null,
                React.createElement(antd_1.Col, { span: 24 },
                    React.createElement(QueryEventVariantsComponent_1.QueryEventVariantsComponent, { queryEventVariantsSerializedState: funnelQueryJSONModelSerializedState, onChange: pageModelContext.pageModelStateFns.onEventsChanged, transformOptions: transformOptionsFn }))),
            React.createElement(antd_1.Row, { className: "drawButtonRow" },
                React.createElement(antd_1.Col, { span: 24 },
                    React.createElement(ChartShowButtonComponent_1.ChartShowButtonComponent, { inProgress: pageDataContext.state.status.inProgress, onClick: pageModelContext.pageModelStateFns.show, disabled: showButtonDisabled })))));
};
exports.FunnelFormComponent = FunnelFormComponent;
